angular.module('TetherApp').controller('ListUploadParticipantController', [
    '$scope',
    'upload',
    'listService',
    function (
        $scope,
        upload,
        listService
    ) {

        let self = this;

        self.listName = '';

        self.onSuccess = function(response, list, callback) {
            alert('Successfully upload participants');
            callback();
        };

        self.onComplete = function(response) {
            //DO NOTHING
        };

        self.onError = function(reason) {
        };

        self.onUpload = function (data) {
        };

        $scope.cancel = function() {
            $scope.$parent.cancel();
        };
    }
]);
